import { Component } from '@angular/core';

@Component({
    selector: 'app-week-report',
    standalone: true,
    imports: [],
    templateUrl: './week-report.component.html',
    styleUrl: './week-report.component.scss'
})
export class WeekReportComponent {}